import { useCallback, useEffect } from 'react';
import { usePatchFlarelaneUserTags } from '../api/flarelane/usePatchFlarelaneUserTags';
import { useGetUserProfile } from './useGetUserProfile';
import { useGetUserActivityTracking } from '../api/user/queries/useGetUserActivityTracking.query';
import { useGetUserOwnTractorPokesMeCount } from '../api/user/queries/useGetUserOwnTractorPokesMeCount.query';
import { useGetMyOwnTractorImageExists } from '../api/user/queries/useGetMyOwnTractorImageExists.query';

export const useUpdateFlarelaneTag = () => {
  useUpdateTagUserVisitedCountTLP();
  useUpdateTagUserVisitedCountTDP();
  useUpdateTagUserExecutedPokeCount();
  useUpdateTagUserOwnTractorImageExists();
};

const useUpdateTagUserVisitedCountTLP = () => {
  const { userProfile } = useGetUserProfile();
  const { data: userActivityTracking } = useGetUserActivityTracking('TLP');
  const { mutate: patchFlarelaneUserTags } = usePatchFlarelaneUserTags();

  useEffect(() => {
    if (!userProfile) {
      return;
    }

    if (userActivityTracking) {
      const visitedCountTLP = userActivityTracking?.find(
        (activity) => activity.activityType === 'pokeListPageVisitedCount',
      )?.value;

      if (visitedCountTLP !== undefined) {
        patchFlarelaneUserTags({
          visitedCountTLP: String(visitedCountTLP),
        });
      }
    }
  }, [userProfile, userActivityTracking, patchFlarelaneUserTags]);
};

const useUpdateTagUserVisitedCountTDP = () => {
  const { userProfile } = useGetUserProfile();
  const { data: userActivityTracking } = useGetUserActivityTracking('TDP');
  const { mutate: patchFlarelaneUserTags } = usePatchFlarelaneUserTags();

  useEffect(() => {
    if (!userProfile) {
      return;
    }

    if (userActivityTracking) {
      const visitedCountTDP = userActivityTracking?.find(
        (activity) => activity.activityType === 'pokeDetailPageVisitedCount',
      )?.value;

      if (visitedCountTDP !== undefined) {
        patchFlarelaneUserTags({
          visitedCountTDP: String(visitedCountTDP),
        });
      }
    }
  }, [userProfile, userActivityTracking, patchFlarelaneUserTags]);
};

const useUpdateTagUserExecutedPokeCount = () => {
  const { userProfile } = useGetUserProfile();
  const { data: userOwnTractorPokesMeCount } = useGetUserOwnTractorPokesMeCount();
  const { mutate: patchFlarelaneUserTags } = usePatchFlarelaneUserTags();

  useEffect(() => {
    if (!userProfile) {
      return;
    }

    if (userOwnTractorPokesMeCount !== undefined) {
      patchFlarelaneUserTags({
        executedPokeCount: String(userOwnTractorPokesMeCount),
      });
    }
  }, [userProfile, userOwnTractorPokesMeCount, patchFlarelaneUserTags]);
};

const useUpdateTagUserOwnTractorImageExists = () => {
  const { userProfile } = useGetUserProfile();
  const { data: userOwnTractorImageExists } = useGetMyOwnTractorImageExists();
  const { mutate: patchFlarelaneUserTags } = usePatchFlarelaneUserTags();

  useEffect(() => {
    if (!userProfile) {
      return;
    }

    if (userOwnTractorImageExists !== undefined) {
      patchFlarelaneUserTags({
        userOwnTractorImageExists: String(userOwnTractorImageExists),
      });
    }
  }, [userProfile, userOwnTractorImageExists, patchFlarelaneUserTags]);
};
